import React, { Component } from "react";
import email from "../assets/Images/free_email_list.png";
import { withRouter, useParams } from "react-router-dom";
import SpinnerLoad from "./SpinnerLoad";

class EmailHRConfirmation extends Component {
  constructor(props) {
    super(props);
    const eventSnum = new URLSearchParams(this.props.location.search).get(
      "eventSnum"
    );
    this.state = {
      spinner: true,
      eventSnum,
    };
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  onButtonClick() {
    // this.props.history.push("/customer-portal")
    //API call
    console.log({
      event_snum: this.state.eventSnum,
    });
    this.props.onParentAppCall({
      event_snum: this.state.eventSnum,
    });
  }
  render() {
    return (
      <div className="main-content">
        <div className="ccpa-wrapper">
          <div className="ccpa-form email-confirmation">
            <img src={email} alt="Email" className="email-image" />
            <h1 className="text-bold"> One More Step! </h1>
            <h1 className="text-bold">
              Please acknowledge the completion of the request.
            </h1>
            {/* <p>
              Please 
            </p> */}
            <div className="ccpa-form-row position-center clear-both">
              <button
                type="button"
                id="submit-button"
                className="margin-top-3"
                onClick={this.onButtonClick}
              >
                Confirm
              </button>
              <div className="ccpa-message"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(EmailHRConfirmation);



// WEBPACK FOOTER //
// src/components/EmailHRConfirmation.js